import React from "react";

export const GlobeSvg = (props: React.SVGProps<SVGSVGElement>) => {
    const clipId = React.useId();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1344 480"
            fill="none"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M672,.5c370.9,0,671.5,293.7,671.5,656s-300.6,656-671.5,656S.5,1018.8.5,656.5C.5,294.2,301.1.5,672,.5Z"
                    stroke="currentColor"
                />
                <path
                    d="M654,.5c286.8,0,519.5,293.6,519.5,656s-232.7,656-519.5,656S134.5,1018.9,134.5,656.5,367.2.5,654,.5Z"
                    stroke="currentColor"
                />
                <path
                    d="M672,.5c88.1,0,167.9,73.2,225.8,192,57.9,118.7,93.7,282.8,93.7,464s-35.8,345.3-93.7,464c-57.9,118.8-137.8,192-225.8,192s-167.9-73.2-225.8-192c-57.9-118.7-93.7-282.8-93.7-464s35.8-345.3,93.7-464C504.1,73.7,583.9.5,672,.5Z"
                    stroke="currentColor"
                />
                <path
                    d="M672,.5c10.2,0,20.2,4.5,29.9,13.2,9.7,8.7,19.1,21.5,28.1,38.1,17.9,33.2,34.1,81.2,47.6,140.6,27.1,118.8,43.9,282.8,43.9,464.1s-16.8,345.3-43.9,464.1c-13.6,59.4-29.7,107.4-47.6,140.6-9,16.6-18.3,29.4-28.1,38.1-9.7,8.7-19.7,13.2-29.9,13.2s-20.2-4.5-29.9-13.2c-9.7-8.7-19.1-21.5-28.1-38.1-17.9-33.2-34.1-81.2-47.6-140.6-27.1-118.8-43.9-282.8-43.9-464.1s16.8-345.3,43.9-464.1c13.6-59.4,29.7-107.4,47.6-140.6,9-16.6,18.3-29.4,28.1-38.1,9.7-8.7,19.7-13.2,29.9-13.2Z"
                    stroke="currentColor"
                />
                <line
                    x1="930"
                    y1="50.5"
                    x2="414"
                    y2="50.5"
                    stroke="currentColor"
                />
                <line
                    x1="1073"
                    y1="130.5"
                    x2="271"
                    y2="130.5"
                    stroke="currentColor"
                />
                <line
                    x1="1191"
                    y1="240.5"
                    x2="153"
                    y2="240.5"
                    stroke="currentColor"
                />
                <line
                    x1="672.5"
                    y1="0"
                    x2="672.5"
                    y2="1313"
                    stroke="currentColor"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="1344" height="480" fill="none" />
                </clipPath>
            </defs>
        </svg>
    );
};
